import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Navbar from "../components/Navbar";
import { Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import ListingPage from "./ListingPage";
import SellerBuyerForm from "./FormsPage";
import ContactPage from "./ContactUs";
import PropertyEvaluationPage from "./PropertyEvaluationPage";
import PropertyPage from "./PropertyPage";
import ArticlePage from "./Article";
import SoldListing from "./SoldListingPage";
import NotFoundPage from "./NotFoundPage";
import LoginPage from "./LoginPage";
import RegistrationPage from "./RegistrationPage";
import CreatePostPage from "./CreatePost";
import PropertyDataList from "./PropertyDataList";
import PropertyDetailsEdit from "./PropertyDetailsEdit";

const LayoutPage = () => {
  return (
    <Layout className="layout" style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Navbar />
      </Header>
      <Content
        style={{
          width: "100vw",
          // height: "100%",
        }}
      >
        <div>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/propertyListings" element={<ListingPage />} />
            <Route path="/soldListings" element={<SoldListing />} />
            <Route path="/borang" element={<SellerBuyerForm />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/property/:id" element={<PropertyPage />} />
            <Route
              path="/propertyDetailsEdit/:id"
              element={<PropertyDetailsEdit />}
            />
            <Route path="/article" element={<ArticlePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registration" element={<RegistrationPage />} />
            <Route
              path="/propertyEvaluation"
              element={<PropertyEvaluationPage />}
            />
            <Route path="/createPost" element={<CreatePostPage />} />
            <Route path="/propertyDataList" element={<PropertyDataList />} />
            <Route path="/*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </Content>
      <Footer
        // theme="dark"
        style={{
          textAlign: "center",
          backgroundColor: "#696969",
          color: "#fff",
        }}
      >
        Created by Faheem
      </Footer>
    </Layout>
  );
};

export default LayoutPage;
